'use strict';
var login = require('base/login/login');
var otpFunctions = require('../otpfunctions');
if (login) {
    Object.keys(login).forEach((key) => {
        module.exports[key] = login[key];
    });
}

var formValidation = require('base/components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
const { customDropdown } = require('../customDropdown');
const { customCountrySelector } = require('../customCountrySelector');

function formToggle(result) {
    if (result.otpSent) {
        $('.login-forms').addClass('d-none');
        $('.login-form-nav .verify-otp-form').removeClass('d-none');
        if (!result.customerFound) {
            $('#verify-loginotp-form').attr('action', $('.verifyOtpRegistrationAction').val());
        } else{
            // Update OTP varification form action url based on response from ajax
            if(result.actionUrl){
                $('.login-forms').addClass('d-none');
                otpFunctions.otpInputs();
                $('.login-form-nav .verify-otp-profile-form').removeClass('d-none');
                $('#verify-profileotp-form').attr('action', result.actionUrl);
            }
        }

        if (result.isResetPassword) {
            $('#verify-loginotp-form').attr('action', $('.verifyOtpAction').val());
        }
        otpFunctions.timerEvent();
    } else {
        if (result.customerFound && result.medium == 'EMAIL') {
            $('#login-form-email-password').val(result.emailOrMobile);
            result.phoneHome ? $('#login-form-mobile-password').val(result.phoneHome) : $('#login-form-mobile-password').attr('disabled');
            $('.login-forms').addClass('d-none');
            $('.login-form-nav .login-password-form').removeClass('d-none');
            $('.login-form-nav .login-password-form .login-mobile-number').addClass('d-none');
        } else if (result.customerFound && result.medium == "MOBILE") {
            $('#login-form-email-password').val(result.emailOrMobile);
            $('#login-form-mobile-password').val(result.phoneHome);
            $('.login-forms').addClass('d-none');
            $('.login-form-nav .login-password-form').removeClass('d-none');
            $('.login-form-nav .login-password-form .login-email').addClass('d-none');
        } else if (result.customerFound == false && result.medium == 'EMAIL') {
            $('.login-forms').addClass('d-none');
            $('.login-form-nav .login-register-form').removeClass('d-none');
            $('.login-form-nav .phone-registration').removeClass('d-none');
            $('.login-form-nav #registration-form-phone, .login-form-nav #registration-form-password').val('');
            $('.login-form-nav #registration-form-email').length > 0 &&
                ($('.login-form-nav #registration-form-email').val(result.emailOrMobile));
        } else {
            $('.login-forms').addClass('d-none');
            $('.login-form-nav .login-register-form').removeClass('d-none');
            $('.login-form-nav .email-registration').removeClass('d-none');
            $('.login-form-nav #registration-form-email, .login-form-nav #registration-form-password').val('');
            $('.login-form-nav #registration-form-phone').length > 0 &&
                ($('.login-form-nav #registration-form-phone').val(result.emailOrMobile));
        }
    }
}

module.exports = {
    renderLoginModal: function () {
        $(document).on('click', '.login-modal-render', function (e) {
            e.preventDefault();
            var url =$(this).attr('href');
            var currentPage, google, fb;
            $.spinner().start();
            $.ajax({
                url,
                type: 'get',
                success(data) {
                    $.spinner().stop();
                    $('body').append(data);
                    $('#signup-login-popup').modal('show');
                    currentPage = window.location.href;
                    google = $('.social-container #Google').attr('href');
                    fb = $('.social-container #Facebook').attr('href');
                    google = google + '&destination=' + (currentPage && currentPage.includes("stage") ? 'CheckoutPage' : currentPage);
                    fb = fb + '&destination=' + (currentPage && currentPage.includes("stage") ? 'CheckoutPage' : currentPage);
                    $('.social-container #Google').attr('href',google);
                    $('.social-container #Facebook').attr('href',fb);
                },
                error() {
                    $.spinner().stop();
                },
            });
            return false;
        });

        $(document).on('hidden.bs.modal', '#signup-login-popup', function () {
            $('body').find('#signup-login-popup').remove();
            $('footer').attr('data-url', '');
        })
        sessionStorage.setItem('movingToCheckout', false);
        
        $(document).on('shown.bs.modal', '#signup-login-popup', function () {
            if (sessionStorage.getItem('movingToCheckout') === "true") {
                $('.guest-checkout-login-button-container').removeClass('d-none');
                var google = $('.social-container #Google').attr('href');
                var fb = $('.social-container #Facebook').attr('href');
                fb = fb +'&checkoutLogin=true';
                google = google +'&checkoutLogin=true';
                $('.social-container #Google').attr('href',google);
                $('.social-container #Facebook').attr('href',fb);
            }
            if( $('.page.checkout').length ) {
                $('.guest-checkout-login-button-container').addClass('d-none');
            }
            if( $('.page.checkout').length ) {
                $('.guest-checkout-login-button-container').addClass('d-none');
            }
        })
    }
,
    numberEntry: function () {
        $(document).keyup('#login-form-email-otp, #login-form-email-with-password', function () {
            if ($(this.activeElement).parent('.form-group').find('.selected-countryCode').length) {
                if (!isNaN($(this.activeElement).val()) && $(this.activeElement).val() !== '') {
                    $(this.activeElement).parent('.form-group').addClass('numberEntered');
                    $(this.activeElement).siblings('.selected-countryCode').removeClass('d-none');
                } else if (isNaN($(this.activeElement).val()) || $(this.activeElement).val() === '') {
                    if (!$('input[name="gkOtpLogin"]').length) {
                        $(this.activeElement).parent('.form-group').removeClass('numberEntered');
                        $(this.activeElement).siblings('.selected-countryCode').addClass('d-none');
                    }
                }
            }
        });

        $(document).on('blur', '#login-form-email-otp, #login-form-email-with-password', function () {
            if ($(this).parent('.form-group').find('.selected-countryCode').length) {
                if ($(this).val() === '') {
                    if (!$('input[name="gkOtpLogin"]').length) {
                        $(this).parent('.form-group').removeClass('numberEntered');
                        $(this).siblings('.selected-countryCode').addClass('d-none');
                    }
                }
            }

            if ($(this).val() !== '') {
                $(this).val($.trim($(this).val()));
            }
        });
    },
    login: function () {
        $(document).on('submit', 'form.login-password', function (e) {
            $('.login-forms').removeClass('last-active');
            $('.login-form-password').addClass('last-active');
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.login-password').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.error) {
                        if (data.customerFound) {
                            if (data.isMigrated) {
                                $('.login-forms').addClass('d-none');
                                $('.reset-password-form').removeClass('d-none');
                                if ($('.form-group.login-email').hasClass('d-none')) {
                                    $('#reset-password-email').val($('#login-form-mobile-password').val());
                                } else {
                                    $('#reset-password-email').val($('#login-form-email-with-password').val());
                                }
                            } else {
                                formToggle(data);
                                if (data.medium === "MOBILE") {
                                    var regId = "+91 "+data.emailOrMobile;
                                } else {
                                    var regId = data.emailOrMobile;
                                }
                                if ($('.registration-id').length) {
                                    $('.registration-id').text(regId);
                                }
                            }
                        } else {
                            formToggle(data);
                            if (data.medium === "MOBILE") {
                                var regId = "+91 "+data.emailOrMobile;
                            } else {
                                var regId = data.emailOrMobile;
                            }
                            if ($('.registration-id').length) {
                                $('.registration-id').text(regId);
                            }
                        }
                        /*window.dataLayer.push({
                            event: "User_Login",
                            click_text: "CONTINUE",
                            section_clicked: "via Password",
                            userID: '',
                            nextPage: window.location.href,
                            currentPage: window.location.href
                        });*/
                    } else {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    },
    checkUser: function () {
        $(document).on('submit', 'form.login', function (e) {
            var form = $(this);
            var url = form.attr('action');
            e.preventDefault();
            form.spinner().start();
            $('form.login').trigger('login:submit', e);

            var pageAction = $('.page').attr('data-action');
            form.find('input[name="loginSourcePage"]').val(pageAction);

            let userInput = form.find('#login-form-email-password');
            if (userInput.val() !== '' && !userInput.hasClass('is-invalid')) {
                form.spinner().start();
                $.ajax({
                    url: url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success(data) {
                        form.spinner().stop();
                        if (!data.error) {
                            if (!data.success) {
                                if (data.errorMessage !== '') {
                                    if (form.find('.alert-danger').length) {
                                        form.find('.alert-danger').text(`${data.errorMessage}`);
                                    } else {
                                        form.prepend(`<div class="alert alert-danger" role="alert">${data.errorMessage}</div>`);
                                    }
                                }
                                form.trigger('login:error', data);
                            } else {
                                // Google analytics
                                window.dataLayer.push({
                                    event: "User_Login",
                                    click_text: "SUBMIT", //need to pass dynamic value like proceed, verify OTP etc
                                    section_clicked: "via Password", //need to pass info dynamically like proceed or OTP verification
                                    currentPage: window.location.href, //Need to pass current page url
                                    nextPage: window.location.href, //Need to pass next page url
                                    user_id: data.customerId //user id of logged in user
                                    }
                                );
                                otpFunctions.otpInputs();
                                otpFunctions.handleAutoFillOTP();
                                if($('footer').attr('data-url')) {
                                    location.href = $('footer').attr('data-url');
                                    return false;
                                }
                                if (sessionStorage.getItem('movingToCheckout') === "true") {
                                    sessionStorage.setItem('movingToCheckout', false);
                                    if (data.isCheckoutLogin) {
                                        window.location.href = data.redirectCheckoutURL;
                                    } else if (data.cartUrl) {
                                        window.location.href = data.cartUrl;
                                    } else {
                                        window.location.href = $('.checkout-url').data('checkout-url');
                                    }
                                } else {
                                    location.reload();
                                }
                            }
                        } else {
                            formValidation(form, data);
                            $('form.login').trigger('login:error', data);
                        }
                    },
                    error() {
                        form.spinner().stop();
                    },
                });
            } else {
                userInput.addClass('is-invalid');
                userInput.parent().addClass('is-invalid');
                userInput.parent().find('.invalid-feedback').text('Please enter email address').show();
            }

            return false;
        });
    },
    loginOTP() {
        $(document).on('submit', 'form.login-otp', function (e) {
            $('.login-forms').removeClass('last-active');
            $('.login-form-otp').addClass('last-active');
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.login-otp').trigger('login:submit', e);
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success(data) {
                    form.spinner().stop();
                    if (!data.error) {
                        if (data.customerFound) {
                            $('.verify-otp-form .alert').remove();
                            if(data.isGkLogin){
                             __KP_LOGIN_SDK_INSTANCE__.kpSendOTP(data.emailOrMobile).then(function (kpResponseData) {
                                    if(kpResponseData.status === 200){
                                        data.otpSent = true;
                                        formToggle(data);
                                        if($('.registration-id').length) {
                                                $('.registration-id').text("+91 "+data.emailOrMobile);
                                            }
                                            otpFunctions.otpInputs();
                                            otpFunctions.handleAutoFillOTP();
                                    }else{
                                        formValidation(form, data);
                                        $('form.login-otp').trigger('login:error', data);
                                    }
                                }).catch(function (kpResponseError) {
                                     formValidation(form, data);
                                    $('form.login-otp').trigger('login:error', data);
                                });
                            }else{
                               if (data.otpSent) {
                                    formToggle(data);
                                    if (data.medium === "MOBILE") {
                                        var regId = "+91 "+data.emailOrMobile;
                                    } else {
                                        var regId = data.emailOrMobile;
                                    }
                                    if ($('.registration-id').length) {
                                        $('.registration-id').text(regId);
                                    }
                                    otpFunctions.otpInputs();
                                    otpFunctions.handleAutoFillOTP();
                                }else {
                                    formValidation(form, data);
                                    $('form.login-otp').trigger('login:error', data);
                                }
                            }
                            
                        } else {
                            formToggle(data);
                            if (data.medium === "MOBILE") {
                                var regId = "+91 "+data.emailOrMobile;
                            } else {
                                var regId = data.emailOrMobile;
                            }
                            if ($('.registration-id').length) {
                                $('.registration-id').text(regId);
                            }
                            
                        }
                        /*window.dataLayer.push({
                            event: "User_Login",
                            click_text: "CONTINUE",
                            section_clicked: "via OTP",
                            userID: '',
                            nextPage: window.location.href,
                            currentPage: window.location.href
                        });*/
                    } else {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    }
                },
                error(data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login-otp').trigger('login:error', data);
                        form.spinner().stop();
                    }
                },
            });
            return false;
        });
    },
    register: function () {
        $(document).on('submit', 'form.registration', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.registration').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.error) {
                       if(data.isGkRegistration){
                         __KP_LOGIN_SDK_INSTANCE__.kpSendOTP(data.emailOrMobile).then(function (kpResponseData) {
                                    if(kpResponseData.status === 200){
                                        formToggle(data);
                                        if (data.medium === "MOBILE") {
                                            var regId = "+91 "+data.emailOrMobile;
                                        } else {
                                            var regId = data.emailOrMobile;
                                        }
                                        if ($('.registration-id').length) {
                                            $('.registration-id').text(regId);
                                        }
                                        otpFunctions.otpInputs();
                                        otpFunctions.handleAutoFillOTP();
                                    }else{
                                        formValidation(form, data);
                                        $('form.login-otp').trigger('login:error', data);
                                    }
                                }).catch(function (kpResponseError) {
                                     if (Object.keys(data.fields).length > 0 && data.fields[Object.keys(data.fields)[0]] === "Password must contain 8 - 255 characters.") {
                                        $('#form-password-error.invalid-feedback')
                                        .css('display', 'block')
                                        .text(`${data.fields[Object.keys(data.fields)[0]]}`);
                                            $('#registration-form-password').addClass('is-invalid');
                                        } else {
                                            formValidation(form, data);
                                        }
                                        $('form.registration').trigger('login:register:error', data);
                                });
                       }else{
                            if (data.otpSent) {
                                formToggle(data);
                                if (data.medium === "MOBILE") {
                                    var regId = "+91 "+data.emailOrMobile;
                                } else {
                                    var regId = data.emailOrMobile;
                                }
                                if ($('.registration-id').length) {
                                    $('.registration-id').text(regId);
                                }
                                otpFunctions.otpInputs();
                                otpFunctions.handleAutoFillOTP();
                            } else {
                                if (Object.keys(data.fields).length > 0 && data.fields[Object.keys(data.fields)[0]] === "Password must contain 8 - 255 characters.") {
                                    $('#form-password-error.invalid-feedback')
                                    .css('display', 'block')
                                    .text(`${data.fields[Object.keys(data.fields)[0]]}`);
                                    $('#registration-form-password').addClass('is-invalid');
                                } else {
                                    formValidation(form, data);
                                }
                                $('form.registration').trigger('login:register:error', data);
                            }
                        }
                    } else {
                        formValidation(form, data);
                        $('form.registration').trigger('login:register:error', data);
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }

                    form.spinner().stop();
                }
            });
            return false;
        });
    },
    verifyOTP() {
        $(document).on('submit', '#verify-loginotp-form', function (e) {
             e.preventDefault();
             var form = $(this);
            var formModal = $('#verify-loginotp-form');
            formModal.spinner().start();
            var url = form.attr('action');
             $('.verify-otp-form .alert').remove();

            var pageAction = $('.page').attr('data-action');
            form.find('input[name="loginSourcePage"]').val(pageAction);

            // Check for GK login
            if ($('input[name="gkOtpLogin"]').length) {
                // var mobileNumber = $('#verify-loginotp-form .registration-id').text().replace(/^\+91\s?/, '');
                var mobileNumber = $(this).closest('form').find('.registration-id').text().trim().replace(/^\+91\s?/, '');
                var otp = '';
                $('.otpInput').each(function () {
                otp += $(this).val();
                });
                __KP_LOGIN_SDK_INSTANCE__.kpVerifyOTP({phone: mobileNumber, otp: parseInt(otp)}).then(function (kpResponseData) {
                    if(kpResponseData.status === 200){
                                        $('#gkOtpToken').val(kpResponseData.body.data.kpToken);
                                        $('#gkOtpVerifyStatus').val(true);
                                        $.ajax({
                                            url,
                                            type: 'post',
                                            dataType: 'json',
                                            data: form.serialize(),
                                            success(data) {
                                                $('#gkOtpToken').val('');
                                                $('#gkOtpVerifyStatus').val(false);
                                                formModal.spinner().stop();
                                                if (!data.success) {
                                                    formValidation(form, data);
                                                } else {
                                                    // Google analytics
                                                    window.dataLayer.push( {
                                                        event: "User_Login",
                                                        click_text: "verify OTP", //need to pass dynamic value like proceed, verify OTP etc
                                                        section_clicked: "via OTP", //need to pass info dynamically like proceed or OTP verification
                                                        currentPage: window.location.href, //Need to pass current page url
                                                        nextPage: window.location.href, //Need to pass next page url
                                                        user_id: data.customerId //user id of logged in user
                                                        }
                                                    );
                                                    otpFunctions.handleAutoFillOTP();
                                                    if($('footer').attr('data-url')) {
                                                        location.href = $('footer').attr('data-url');
                                                        return false;
                                                    }

                                                    if (data.showLoginConsent) {
                                                        sessionStorage.setItem('showLoginConsent', 'true');
                                                    }

                                                    if (sessionStorage.getItem('movingToCheckout') === "true") {
                                                        sessionStorage.setItem('movingToCheckout', false);
                                                        if (data.cartUrl) {
                                                            window.location.href = data.cartUrl;
                                                        } else {
                                                            window.location.href = $('.checkout-url').data('checkout-url');
                                                        }
                                                    } else {
                                                        if (!$('.reset-password-form').hasClass('last-active')) {
                                                            location.reload();
                                                        }
                                                    }
                                                    if ($('.reset-password-form').hasClass('last-active')) {
                                                        $('.login-forms').addClass('d-none');
                                                        $('.create-new-password-form').removeClass('d-none');
                                                    }
                                                }
                                            },
                                            error() {
                                                formModal.spinner().stop();
                                            },
                                        }); 
                                    }else{
                                        $('#gkOtpToken').val(null);
                                        $('#gkOtpVerifyStatus').val(false);
                                        if (form.find('.alert-danger').length) {
                                           form.find('.alert-danger').text(`${kpResponseData.message}`);
                                        } else {
                                            form.prepend(`<div class="alert alert-danger" role="alert">${kpResponseData.message}</div>`);
                                        }
                                         formModal.spinner().stop();
                                    }  
                                    
                                }).catch(function (kpResponseError) {
                                    if (form.find('.alert-danger').length) {
                                           form.find('.alert-danger').text('Verification failed.');
                                        } else {
                                            form.prepend(`<div class="alert alert-danger" role="alert">Verification failed.</div>`);
                                        }
                                    $('#gkOtpToken').val(null);
                                    $('#gkOtpVerifyStatus').val(false);
                                     formModal.spinner().stop();
                                });
            }else{
                    $.ajax({
                        url,
                        type: 'post',
                        dataType: 'json',
                        data: form.serialize(),
                        success(data) {
                            formModal.spinner().stop();
                            if (!data.success) {
                                formValidation(form, data);
                            } else {
                                // Google analytics
                                window.dataLayer.push( {
                                    event: "User_Login",
                                    click_text: "verify OTP", //need to pass dynamic value like proceed, verify OTP etc
                                    section_clicked: "via OTP", //need to pass info dynamically like proceed or OTP verification
                                    currentPage: window.location.href, //Need to pass current page url
                                    nextPage: window.location.href, //Need to pass next page url
                                    user_id: data.customerId //user id of logged in user
                                    }
                                );
                                otpFunctions.handleAutoFillOTP();

                                if (data.showLoginConsent) {
                                    sessionStorage.setItem('showLoginConsent', 'true');
                                }

                                if (data.isCustomerPriceBook) {
                                    window.location.href = data.redirectUrl;
                                    return;
                                }

                                if($('footer').attr('data-url')) {
                                    location.href = $('footer').attr('data-url');
                                    return false;
                                }
                                if (sessionStorage.getItem('movingToCheckout') === "true") {
                                    sessionStorage.setItem('movingToCheckout', false);
                                    if (!($('.reset-password-form').hasClass('last-active'))) {
                                        if (data.isCheckoutLogin) {
                                            window.location.href = data.redirectCheckoutURL;
                                        } else {
                                            window.location.href = data.cartUrl;
                                        }
                                    }
                                    // if (data.cartUrl) {
                                    //     window.location.href = data.cartUrl;
                                    // } else {
                                    //     window.location.href = $('.checkout-url').data('checkout-url');
                                    // }
                                } else {
                                    if (!$('.reset-password-form').hasClass('last-active')) {
                                        location.reload();
                                    }
                                }
                                if ($('.reset-password-form').hasClass('last-active')) {
                                    $('.login-forms').addClass('d-none');
                                    $('.create-new-password-form').removeClass('d-none');
                                }
                            }
                        },
                        error() {
                            formModal.spinner().stop();
                        },
                    });
            }
            return false;
        });

    },
    switchToLogin: function() {
        $(document).on('click', '#modalPasswordLink', function(e) {
            e.preventDefault();
            $('.login-forms').addClass('d-none');
            $('.login-form-password').removeClass('d-none');
        });
    },
    resetPassword: function () {
        $(document).on('submit', '.reset-password-form', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.error) {
                        $('.login-forms').addClass('d-none');
                        $('.verify-otp-form').removeClass('d-none');
                        $('.login-forms').removeClass('last-active');
                        $('.reset-password-form').addClass('last-active');
                        if (data.medium === "MOBILE") {
                            var regId = "+91 " + data.emailOrMobile;
                        } else {
                            var regId = data.emailOrMobile;
                        }
                        if ($('.registration-id').length) {
                            $('.registration-id').text(regId);
                        }
                        // formToggle(data);
                        otpFunctions.timerEvent();
                        otpFunctions.otpInputs();
                        otpFunctions.handleAutoFillOTP();
                        if (!data.success) {
                            formValidation(form, data);
                        } else {
                            $('.request-password-title').text(data.receivedMsgHeading);
                            $('.request-password-body').empty()
                                .append('<p>' + data.receivedMsgBody + '</p>');
                            if (!data.mobile) {
                                $('#submitEmailButton').text(data.buttonText)
                                    .attr('data-dismiss', 'modal');
                            } else {
                                $('.send-email-btn').empty()
                                    .html('<a href="'
                                        + data.returnUrl
                                        + '" class="btn btn-primary btn-block">'
                                        + data.buttonText + '</a>'
                                    );
                            }
                        }
                    } else {
                        formValidation(form, data);
                        $('form.reset-password-form').trigger('login:error', data);
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },
    logOutKP() {
       $(document).on('click', '#logout-button-kp', function(event) {
        event.preventDefault();
         __KP_LOGIN_SDK_INSTANCE__.handleKPLogout();
        var redirectUrl = $(this).attr('href');
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
    }); 
    },
    resendOTP() {
        $(document).on('click', '.resendButton', function (e) {
            var element = $(this);
            e.preventDefault();
            var formModal = $(this).closest('form');
            var url = element.attr('href');
            formModal.spinner().start();
            // It's GK Login then resend the OTP here only
        if ($('input[name="gkOtpLogin"]').length) {
                var mobileNumber = $('#verify-loginotp-form .registration-id').text().replace(/^\+91\s?/, '');
               __KP_LOGIN_SDK_INSTANCE__.kpSendOTP(mobileNumber).then(function (kpResponseData) {
                            if(kpResponseData.status === 200){
                                    console.log('OTP Resent Successfully');
                            }else{
                                console.log('Error In Otp Resend'); 
                            }
                        }).catch(function (kpResponseError) {
                            console.log('Error In Otp Resend');

             });
            }
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: $('#verify-loginotp-form').serialize(),
                success(data) {
                    formModal.spinner().stop();
                    if (!data.otpSent) {
                        $('.resendButton').css('display', 'none');
                        $('.resendCounter')
                            .css({ display: 'block', color: '#f00' })
                            .html(data.error[0]);
                    } else {
                        clearInterval(window.downloadTimer);
                        var otpSessionCounter = sessionStorage.getItem('otpCounter');
                        if (otpSessionCounter < 3) {
                            otpSessionCounter++;
                            sessionStorage.setItem('otpCounter', otpSessionCounter);
                        }   
                        $('.resendCounter').html('').css('display', 'none');
                        $('.resendButton').css('display', 'block');
                        otpFunctions.handleAutoFillOTP();
                        otpFunctions.multiTimerEvent();
                    }
                },
                error() {
                    formModal.spinner().stop();
                },
            });
            return false;
        });
    },
    clearResetForm: function () {
        $('#signup-login-popup').on('hidden.bs.modal', function () {
            $(this)
                .find("input")
                .val('')
                .end()
                .find("input[type=checkbox]")
                .prop("checked", "")
                .end();
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
            $('.login-forms').removeClass('d-none').addClass('d-none');
            $('.login-forms.login-form-otp').removeClass('d-none');
            clearInterval(window.downloadTimer);
            $('.resendCounter').html('').css('display', 'none');
            $('.resendButton').css('display', 'block');
        });
        $('#my-account-edit-popup').on('hidden.bs.modal', function () {
            $(this)
                .find("input")
                .val('')
                .end()
                .find("input[type=checkbox]")
                .prop("checked", "")
                .end();
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
            $('.login-forms').removeClass('d-none').addClass('d-none');
            $('.login-forms.login-form-otp').removeClass('d-none');
            clearInterval(window.downloadTimer);
            $('.resendCounter').html('').css('display', 'none');
            $('.resendButton').css('display', 'block');
        });
    },
    ChangePassword: function () {
        $(document).on('submit', '#change-password-form', function (e) {
            var form = $(this);
            e.preventDefault();
            var formModal = $('#verify-loginotp-form');
            var url = form.attr('action');
            formModal.spinner().start();

            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success(data) {
                    if(data.error){
                        formValidation(form, data);
                        $('form.change-password-form').trigger('login:error', data);
                    }
                    else {
                        formModal.spinner().stop();
                        location.reload();
                    }
                },
                error() {
                    formModal.spinner().stop();
                },
            });
        });
    },

    backButton: function () {
        $(document).on('click', '.edit-form', function () {
            $(this).closest('form').parent().addClass('d-none');
            $('.last-active').removeClass('d-none');
            $('.registration .email-registration').addClass('d-none');
            $('.registration .phone-registration').addClass('d-none');
            clearInterval(window.downloadTimer);
            $('.resendCounter').html('').css('display', 'none');
            $('.resendButton').css('display', 'block');
        });
    },

    loginMethodSwitch: function () {
        $(document).on('click', '.login-footer-link a:not(.checkout-as-guest)', function (e) {
            e.preventDefault();
            if ($(this).hasClass('viaOtp')) {
                $('.login-form-otp').removeClass('d-none');
                $('.login-form-password').addClass('d-none');
            } else if ($(this).hasClass('viaPassword')) {
                $('.login-form-otp').addClass('d-none');
                $('.login-form-password').removeClass('d-none');
            }
        })
    },

    resetPasswordShow: function () {
        $(document).on('click', '.forgot-password a', function (e) {
            e.preventDefault();
            $('.login-forms').addClass('d-none');
            if ($('.form-group.login-email').hasClass('d-none')) {
                $('#reset-password-email').val($('#login-form-mobile-password').val());
            } else {
                $('#reset-password-email').val($('#login-form-email-with-password').val());
            }
            $('.reset-password-form').removeClass('d-none');
        })
    },

    editProfile : function(){
        /* 
        * Author : Sanjeev Kumar Sharma
        * Funcitonality : Send OTP on regitered email and open OTP varification Modal
        */
        $(document).on('click', '.account-info .profile-edit a', function(e) {
            e.preventDefault();

            var url = $(this).attr('href');
            $.spinner().start();
            $.ajax({
                url,
                type: 'post',
                success(data) {
                    $.spinner().stop();
                    if(data.isExtAuthenticatedNoEmailOrMobile){
                        loadProfilDataEdit(data.actionUrl);
                    }else{
                        if (data.customerFound) {
                            if (data.otpSent) {
                                $('#my-account-edit-popup').modal('show');
                                formToggle(data);
                                if ($('.registration-id').length) {
                                    $('.registration-id').text(data.emailOrMobile);
                                }
                                otpFunctions.otpInputs();
                                otpFunctions.handleAutoFillOTP();
                            }
                            else {
                                formValidation(form, data);
                                $('form.login-otp').trigger('login:error', data);
                            }
                        } else {
                            formToggle(data);
                            if ($('.registration-id').length) {
                                $('.registration-id').text(data.emailOrMobile);
                            }
                        }
                    }

                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        /* 
        * Author : Sanjeev Kumar Sharma
        * Funcitonality : Handle OTP submit form when used for update profile and update password
        */
        $(document).on('submit', '#verify-profileotp-form', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success(data) {
                    $.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        otpFunctions.handleAutoFillOTP();
                        $('#my-account-edit-popup').modal('hide');
                        
                        if(!data.redirectUrl){
                            if(data.actionUrl.includes('EditProfile') || data.actionUrl.includes('profile')){
                                loadProfilDataEdit(data.actionUrl);
                            }
                            else{
                                loadPasswordDataEdit(data.actionUrl);
                            }
                        }else{
                            location.href =data.redirectUrl;
                        }
                    }
                },
                error() {
                    $.spinner().stop();
                },
            });
            return false;
        });

        /* 
        * Author : Sanjeev Kumar Sharma
        * Funcitonality : Ajax call to update edit profile with user data in modal
        */

        function loadProfilDataEdit(url){
            $.spinner().start();
            $.ajax({
                url,
                type: 'get',
                success(data) {                    
                    var editProfileSection = $('.edit-profile-section');
                    editProfileSection.find('.modal-body .edit-data').html(data);
                    editProfileSection.removeClass('d-none');
                    customDropdown();       

                    var today = new Date();
                    var dd = today.getDate();
                    var mm = today.getMonth() + 1; //January is 0!
                    var yyyy = today.getFullYear();

                    if (dd < 10) {
                        dd = '0' + dd;
                    }
                    if (mm < 10) {
                        mm = '0' + mm;
                    }
                    
                    today = yyyy + '-' + mm + '-' + dd;

                    $('#birthday').attr('max',today);

                    setTimeout(function(){
                        $.spinner().stop();
                    $('#profile-edit-popup').modal('show');
                    },500);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
        
        /* 
        * Author : Sanjeev Kumar Sharma
        * Funcitonality : Ajax call to update Password modal
        */

        function loadPasswordDataEdit(url){
            $.spinner().start();
            $.ajax({
                url,
                type: 'get',
                success(data) {
                    $('.edit-password-section').html(data);                    
                    setTimeout(function(){
                        $.spinner().stop();
                        $('#password-update-popup').modal('show');
                    },500);
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }

        /* 
        * Author : Sanjeev Kumar Sharma
        * Funcitonality : handle submit profile edit form, validate form field, after submit relaoad page to display updated data
        */
        $(document).on('submit', '#edit-profile-form', function (e) {
            e.preventDefault();
            var form = $(this);
            var url = form.attr('action');
            form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        form.spinner().stop();
                        location.reload();
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });


    },
    editPhone : function() {
        /* 
        * Author : Sanjeev Kumar Sharma
        * Funcitonality : On click link open modal to entter new phone number 
        */
        $(document).on('click', '.account-info .phone-edit a', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $.spinner().start();
            $.ajax({
                url,
                type: 'get',
                success(data) {                    
                    $('.edit-phone-section').html(data);
                    setTimeout(function(){
                        $.spinner().stop();
                        customCountrySelector();
                        $('#verifyOTPPhoneModal').modal('show');
                    },500);
                },
                error(error) {
                    $.spinner().stop();
                    console.log('error: ', error)
                }
            });
            return false;
        });
        
        /* 
        * Author : Sanjeev Kumar Sharma
        * Funcitonality : Handle Form submit for update new phone number, display proper error message
        */
        $(document).on('submit', '#update-NewPhone-Otp-form', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success(data) {
                    $.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $('#form-phone-error').html(data.fields.dwfrm_profile_customer_phone).show();
                    } else {                  
                        if (data.otpSent) {
                            $('#form-phone-error').html('').hide();
                            $('#verifyOTPPhoneModal').modal('hide');

                            setTimeout(function(){
                                if ($('#verify-profileotp-form .registration-id').length) {
                                    var t = '+' + $('#countryCode option').attr('rel') + data.msg.split(':')[1];
                                    $('#verify-profileotp-form .registration-id').text(t);
                                }
                                formToggle(data);
                                $('#my-account-edit-popup').modal('show');
                                
                            },1000);
                            otpFunctions.otpInputs();
                            otpFunctions.handleAutoFillOTP();                            
                        } else {
                            location.reload();
                        }
                    }
                },
                error() {
                    $.spinner().stop();
                },
            });
            return false;
        });        
    },
    
    editPassword : function() {
        /* 
        * Author : Sanjeev Kumar Sharma
        * Funcitonality : Open OTP modal for password change 
        */
        $(document).on('click', '.account-info .password-edit a', function(e) {
            e.preventDefault();
            var url = $(this).attr('href');
            $.spinner().start();
            $.ajax({
                url,
                type: 'get',
                success(data) {
                    $.spinner().stop();
                    if (data.otpSent) {
                        $('#my-account-edit-popup').modal('show');
                        formToggle(data);
                        if ($('.registration-id').length) {
                            $('.registration-id').text(data.emailOrMobile);
                        }
                        otpFunctions.otpInputs();
                        otpFunctions.handleAutoFillOTP();
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });

        /* 
        * Author : Sanjeev Kumar Sharma
        * Funcitonality : Update password on form submit
        */
        $(document).on('submit', '#password-update-popup form', function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            $.spinner().start();
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success(data) {
                    $.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('#password-update-popup').modal('hide');                         
                        location.reload();
                    }
                },
                error() {
                    $.spinner().stop();
                },
            });
            return false;
        });

    },

    /* 
    * Author : Sanjeev Kumar Sharma
    * Funcitonality : Subscribe / Unsubscribe Newsletter from user's profile 
    */
    newsLetterSubscription : function() {
        $('.account-info #newsletterSubscription').on('change', function(e) {
            e.preventDefault();
            var successMsg = $(this).attr('data-subscribe');
            var unsubscriptionMsg = $(this).attr('data-unsubscription');
            var checkbox = $(this);
            var anchorUrl = checkbox.data('url');
            $.spinner().start();
            $.ajax({
                url: anchorUrl,
                type: 'GET',
                success: function(data) {
                    $.spinner().stop();
                    if (checkbox.is(':checked')) {
                        $('.news-letter-subscribe .newsletter-feedback.input-success p').empty().html(successMsg);
                    } else {
                        $('.news-letter-subscribe .newsletter-feedback.input-success p').empty().html(unsubscriptionMsg);
                    }
                    $('.news-letter-subscribe .input-success').removeClass('d-none');
                    setTimeout(function() {
                        $('.news-letter-subscribe .newsletter-feedback.input-success, .news-letter-subscribe .newsletter-feedback.input-success.unsubscription').addClass('d-none');
                    }, 3000);
                }
            });
        });
    },
    continueAsGuest : function() {
        $(document).on('click', '.login-footer-link a.checkout-as-guest', function(e) {
            let redirectLink = $(this).attr('href');
            // Google analytics
            window.dataLayer.push({
                event: "User_Login",
                click_text: "Continue_As_A_Guest", //need to pass dynamic value like proceed, verify OTP etc
                section_clicked: "GuestCheckout", //need to pass info dynamically like proceed or OTP verification
                currentPage: window.location.href, //Need to pass current page url
                nextPage: redirectLink, //Need to pass next page url
                user_id: '' //user id of logged in user
                }
            );
        });
    },
    /* 
    * Author : Sanjeev Kumar Sharma
    * Funcitonality : track social login funcitonality 
    */
    socialLoginTrace : function() {
        $(document).delegate('.login-oauth .social-container a', 'click', (event) => {
            let name = $(event.target).attr('id');
            sessionStorage.setItem('loginMethod', name);
        });

        $(document).ready(() => {
            // Login success and failure method
            if (sessionStorage.getItem('loginMethod') !== '' && sessionStorage.getItem('loginMethod') !== null && sessionStorage.getItem('loginMethod') !== 'undefined') {
                let loginMethod = sessionStorage.getItem('loginMethod');
                let url = $('#customerNoUrl').val();
                let customerId;
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success(dataFromAjax) {
                        if(dataFromAjax.customerId){
                            customerId = dataFromAjax.customerId;
                            window.dataLayer.push({
                                event: "User_Login",
                                click_text: "Social media Login", //need to pass dynamic value like proceed, verify OTP etc
                                section_clicked: loginMethod, //need to pass info dynamically like proceed or OTP verification
                                currentPage: window.location.href, //Need to pass current page url
                                nextPage: window.location.href, //Need to pass next page url
                                user_id: customerId //user id of logged in user
                                }
                            );
                        }
                    }
                });
                sessionStorage.removeItem('loginMethod');
            }
        }); 
    }
};